export const nonStandardExpressions = [
  "@annually",
  "@daily",
  "@hourly",
  "@monthly",
  "@reboot",
  "@weekly",
  "@yearly",
];
